"use strict";
/*
 * Created on 11. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Base class for timeline attributes - results of timeline calculations.
 *
 * @author Stepan Mik
 */
//tslint:disable:max-classes-per-file


var TimelineAttribute =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(TimelineAttribute, _AdtFlag_1$AdtFlag);

  function TimelineAttribute() {
    _classCallCheck(this, TimelineAttribute);

    return _possibleConstructorReturn(this, _getPrototypeOf(TimelineAttribute).apply(this, arguments));
  }

  _createClass(TimelineAttribute, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(TimelineAttribute, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(TimelineAttribute, data);
    }
  }]);

  return TimelineAttribute;
}(AdtFlag_1.AdtFlag);

exports.TimelineAttribute = TimelineAttribute;
TimelineAttribute.TAG = '__TimelineAttribute__';

var BasicStatistics =
/*#__PURE__*/
function (_TimelineAttribute) {
  _inherits(BasicStatistics, _TimelineAttribute);

  function BasicStatistics(mean, median, quartil25, quartil75, size) {
    var _this;

    _classCallCheck(this, BasicStatistics);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicStatistics).call(this));
    _this.mean = mean;
    _this.median = median;
    _this.quartil25 = quartil25;
    _this.quartil75 = quartil75;
    _this.size = size;
    return _this;
  }

  _createClass(BasicStatistics, [{
    key: "validate",
    value: function validate() {
      return this.mean instanceof big_decimal_1.BigDecimal && this.median instanceof big_decimal_1.BigDecimal && this.quartil25 instanceof big_decimal_1.BigDecimal && this.quartil75 instanceof big_decimal_1.BigDecimal && typeof this.size === 'number';
    }
  }]);

  return BasicStatistics;
}(TimelineAttribute);

exports.BasicStatistics = BasicStatistics;
BasicStatistics.TAG = TimelineAttribute.register(BasicStatistics);

var NormalDistribution =
/*#__PURE__*/
function (_TimelineAttribute2) {
  _inherits(NormalDistribution, _TimelineAttribute2);

  function NormalDistribution(value) {
    var _this2;

    _classCallCheck(this, NormalDistribution);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(NormalDistribution).call(this));
    _this2.value = value;
    return _this2;
  }

  _createClass(NormalDistribution, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return NormalDistribution;
}(TimelineAttribute);

exports.NormalDistribution = NormalDistribution;
/**
 * It is marking attribute - holds no data, result of marking should be written to timeline directly.
 */

var OutlierDetection =
/*#__PURE__*/
function (_TimelineAttribute3) {
  _inherits(OutlierDetection, _TimelineAttribute3);

  function OutlierDetection() {
    _classCallCheck(this, OutlierDetection);

    return _possibleConstructorReturn(this, _getPrototypeOf(OutlierDetection).call(this));
  }

  _createClass(OutlierDetection, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return OutlierDetection;
}(TimelineAttribute);

exports.OutlierDetection = OutlierDetection;
/**
 * It is marking attribute - holds no data, result of marking should be written to timeline directly.
 */

var RegularPromoDetection =
/*#__PURE__*/
function (_TimelineAttribute4) {
  _inherits(RegularPromoDetection, _TimelineAttribute4);

  function RegularPromoDetection() {
    _classCallCheck(this, RegularPromoDetection);

    return _possibleConstructorReturn(this, _getPrototypeOf(RegularPromoDetection).call(this));
  }

  _createClass(RegularPromoDetection, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return RegularPromoDetection;
}(TimelineAttribute);

exports.RegularPromoDetection = RegularPromoDetection;